import { useConfigContext } from 'contexts/config';
import { useMonetaryAmount } from 'hooks/useMonetaryAmount';

export const useReferralProgramConfig = () => {
  const { referralProgramConfig } = useConfigContext();

  const { toMonetaryAmount, getUserFiatAmountInMajorUnit } =
    useMonetaryAmount();

  return {
    referralProgramConfig,
    userFiatAmount: referralProgramConfig
      ? getUserFiatAmountInMajorUnit(
          toMonetaryAmount(referralProgramConfig.maxDiscount)
        )
      : undefined,
  };
};
